function t(t){const{clientHeight:e}=t,{paddingTop:o,paddingBottom:a}=getComputedStyle(t);return e-parseFloat(o)-parseFloat(a)}export{t as default};
